import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {faCalendarStar, faImages, faNewspaper, faTags} from '@fortawesome/pro-regular-svg-icons';
import {faCircleXmark, faClock} from '@fortawesome/pro-solid-svg-icons';

import {LangKeyType} from '../../../../provider/locale/translation/type';
import {CalendarPostStatusEnum} from '../../../../service/posts/posts-types';
import {
    CalendarModerationEnum,
    CalendarPublicationTypeEnum,
} from '../../../../service/publications/publications-calendar-type';

import * as styles from './posts-calendar.scss';

// Carries the status colour as a class instead of a hex value, per DESIGN.md §11 — the palette
// anchors and their tints are declared in the stylesheet.
export const STATUS_MODIFIER_BY_CALENDAR_POST_STATUS: Record<CalendarPostStatusEnum, string> = {
    [CalendarPostStatusEnum.publishPlanned]: styles.PostCalendar_status__publishPlanned,
    [CalendarPostStatusEnum.deletePlanned]: styles.PostCalendar_status__deletePlanned,
    [CalendarPostStatusEnum.published]: styles.PostCalendar_status__published,
    [CalendarPostStatusEnum.refreshPlanned]: styles.PostCalendar_status__refreshPlanned,
};

export const TEXT_BY_CALENDAR_POST_STATUS: Record<CalendarPostStatusEnum, LangKeyType> = {
    [CalendarPostStatusEnum.publishPlanned]: 'POSTS__CALENDAR_BADGE__PUBLISH_PLANNED',
    [CalendarPostStatusEnum.deletePlanned]: 'POSTS__CALENDAR_BADGE__DELETE_PLANNED',
    [CalendarPostStatusEnum.published]: 'POSTS__CALENDAR_BADGE__SENT',
    [CalendarPostStatusEnum.refreshPlanned]: 'POSTS__CALENDAR_BADGE__REFRESH_PLANNED',
};

// Legend order follows the publication lifecycle (planned → deleted → sent → auto-updated) rather
// than the enum declaration order.
export const CALENDAR_LEGEND_STATUS_LIST: Array<CalendarPostStatusEnum> = [
    CalendarPostStatusEnum.publishPlanned,
    CalendarPostStatusEnum.deletePlanned,
    CalendarPostStatusEnum.published,
    CalendarPostStatusEnum.refreshPlanned,
];

export const TEXT_IN_YEAR_CARD_BY_POST_STATUS: Record<CalendarPostStatusEnum, LangKeyType> = {
    [CalendarPostStatusEnum.publishPlanned]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__PUBLISH_PLANNED',
    [CalendarPostStatusEnum.deletePlanned]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__DELETE_PLANNED',
    [CalendarPostStatusEnum.published]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__SENT',
    [CalendarPostStatusEnum.refreshPlanned]: 'POSTS__CALENDAR_BADGE__YEAR_CARD__REFRESH_PLANNED',
};

// The badge colour already encodes the status, so the publication type is shown with an icon.
export const ICON_BY_CALENDAR_PUBLICATION_TYPE: Record<CalendarPublicationTypeEnum, IconDefinition> = {
    [CalendarPublicationTypeEnum.post]: faNewspaper,
    // A slide set, matching the icon the create-publication chooser already uses for a Story.
    [CalendarPublicationTypeEnum.story]: faImages,
    [CalendarPublicationTypeEnum.promotion]: faTags,
    [CalendarPublicationTypeEnum.event]: faCalendarStar,
};

// Reuses the publication-list tab labels so the legend and the tabs name the types identically.
export const TEXT_BY_CALENDAR_PUBLICATION_TYPE: Record<CalendarPublicationTypeEnum, LangKeyType> = {
    [CalendarPublicationTypeEnum.post]: 'POSTS__TAB__POSTS',
    [CalendarPublicationTypeEnum.story]: 'POSTS__TAB__STORIES',
    [CalendarPublicationTypeEnum.promotion]: 'POSTS__TAB__PROMOTIONS',
    [CalendarPublicationTypeEnum.event]: 'POSTS__TAB__EVENTS',
};

export const CALENDAR_LEGEND_TYPE_LIST: Array<CalendarPublicationTypeEnum> = [
    CalendarPublicationTypeEnum.post,
    CalendarPublicationTypeEnum.story,
    CalendarPublicationTypeEnum.promotion,
    CalendarPublicationTypeEnum.event,
];

export const TEXT_BY_CALENDAR_MODERATION: Record<CalendarModerationEnum, LangKeyType> = {
    [CalendarModerationEnum.onModeration]: 'POSTS__CALENDAR__MODERATION__ON_MODERATION',
    [CalendarModerationEnum.rejected]: 'POSTS__CALENDAR__MODERATION__REJECTED',
};

// Day cells are too cramped for the moderation state as text, so it renders as a trailing marker
// with the wording moved into a tooltip.
export const ICON_BY_CALENDAR_MODERATION: Record<CalendarModerationEnum, IconDefinition> = {
    [CalendarModerationEnum.onModeration]: faClock,
    [CalendarModerationEnum.rejected]: faCircleXmark,
};
